import api from "./api";
import endpoints from "./endpoints";

export default {
  /**
   * @param {Array} languageCodes
   */
  async get(languageCodes) {
    return (
      await api.get(endpoints.keywordTypes.get, {
        params: { languages: languageCodes }
      })
    ).data;
  },

  /**
   * @param {Array} keywordTypes
   */
  async update(data) {
    return (await api.post(endpoints.keywordTypes.update, data)).data;
  },

  /**
   * @param {Array} keywordTypeIds
   */
  async delete(data) {
    return (await api.post(endpoints.keywordTypes.delete, data)).data;
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api.post(endpoints.keywordTypes.deepL, model, { params: { sourceLanguage: sourceLanguage } }).then((x) => Promise.resolve(x.data));
  }
};
